import React, { useEffect, useState } from "react";
import Header from "../component/common/Header";
import $ from "jquery";
import useAuth from "../hooks/useAuth";
import { GETREQUEST, POSTREQUEST } from "./helpers/ServiceRequest";

function MyAccount() {
  const {
    user,
    updateUser,
    firstName: authFirstName,
    lastName: authLastName,
    userName: authUserName,
    role: authRole,
  } = useAuth();

  const [email, setEmail] = useState(user.email);
  const [emailErr, setEmailErr] = useState(false);
  const [firstName, setFirstName] = useState(authFirstName);
  const [firstNameErr, setFirstNameErr] = useState(false);
  const [lastName, setLastName] = useState(authLastName);
  const [lastNameErr, setLastNameErr] = useState(false);
  const [userName, setUserName] = useState(authUserName);
  const [userNameErr, setUserNameErr] = useState(false);
  const [role, setRole] = useState(authRole);
  const [roleErr, setRoleErr] = useState(false);
  const [current, setCurrent] = useState();
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [disabled, setDisabled] = useState(false);

  useEffect(() => {
    var headerHeight = $("header").outerHeight();
    var mainHeight = $(window).height() - headerHeight;
    $("main").height(mainHeight);
    $("main").css("margin-top", headerHeight + "px");
  });

  useEffect(() => {
    const fetchData = async () => {
      let URL = process.env.REACT_APP_API_URL + "/get-user/" + user.userId;
      let response = await GETREQUEST(URL, user.jwtToken);
      if (response?.data) {
        const userObj = {
          firstName: response.data.FirstName,
          lastName: response.data.LastName,
          role: response.data.Role,
          email: response.data.Email,
          userName: response.data.UserName,
          userId: response.data.UserID,
        };
        setCurrent(String(response.data.Current));
        updateUser(userObj, () => { });
      }
    }
    fetchData();
  }, []);

  const updateProfile = async(e) => {
    e.preventDefault();
    if (firstName == "" && lastName == "") {
      setFirstNameErr(true);
      setLastNameErr(true);
      return false;
    }
    let URL = process.env.REACT_APP_API_URL + "/update-profile";
    let payload = {
      Email: email,
      FirstName: firstName,
      LastName: lastName,
      UserName: userName,
      Role: role,
      Current: parseInt(current),
      UserID: user.userId,
    };
    if (firstName != "" && lastName != "") {
      setDisabled(true);
      let response = await POSTREQUEST(URL, payload, user.jwtToken);
      if (response?.data) {
        setSuccessMessage("Successfully update profile.");
        updateUser({ firstName: firstName, lastName: lastName }, () => {
          setDisabled(false);
        });
        setTimeout(() => {
          setSuccessMessage("");
        }, 1200);
      } else {
        setErrorMessage(response.error?.message);
      }
    } else if (firstName == "") {
      setFirstNameErr(true);
      return false;
    } else if (lastName == "") {
      setLastNameErr(true);
      return false;
    }
  };
  return (
    <React.Fragment>
      <Header />
      <main className="bg-lite-grey overflow-auto">
        <section className="px-4 pt-5 pb-4">
          <div className="row justify-content-center">
            <div className="width-xxl-35 width-xl-44 width-lg-60 width-md-80">
              <div className="card p-4">
                <form onSubmit={updateProfile}>
                  <div className="card-body">
                    <div className="cmb-15 row g-3">
                      <label className="width-sm-25 d-flex align-items-center fs-15 text-dark text-nowrap">
                        Email
                      </label>
                      <div className="col">
                        <input
                          type="email"
                          className={
                            "form-control input-md " +
                            (emailErr ? " is-invalid" : "")
                          }
                          placeholder="Enter Email"
                          onChange={(e) => {
                            setEmailErr(false);
                            setEmail(e.target.value);
                          }}
                          defaultValue={email}
                          disabled={true}
                        />
                      </div>
                    </div>
                    <div className="cmb-15 row g-3">
                      <label className="width-sm-25 d-flex align-items-center fs-15 text-dark text-nowrap">
                        User Name
                      </label>
                      <div className="col">
                        <input
                          type="text"
                          className={
                            "form-control input-md " +
                            (userNameErr ? " is-invalid" : "")
                          }
                          placeholder="Enter User Name"
                          onChange={(e) => {
                            setUserNameErr(false);
                            setUserName(e.target.value);
                          }}
                          defaultValue={userName}
                          disabled={true}
                        />
                      </div>
                    </div>
                    <div className="cmb-15 row g-3">
                      <label className="width-sm-25 d-flex align-items-center fs-15 text-dark text-nowrap">
                        First Name
                      </label>
                      <div className="col">
                        <input
                          type="text"
                          className={
                            "form-control input-md " +
                            (firstNameErr ? " is-invalid" : "")
                          }
                          placeholder="Enter First Name"
                          onChange={(e) => {
                            setFirstNameErr(false);
                            setFirstName(e.target.value);
                          }}
                          defaultValue={firstName}
                        />
                      </div>
                    </div>
                    <div className="cmb-15 row g-3">
                      <label className="width-sm-25 d-flex align-items-center fs-15 text-dark text-nowrap">
                        Last Name
                      </label>
                      <div className="col">
                        <input
                          type="text"
                          className={
                            "form-control input-md " +
                            (lastNameErr ? " is-invalid" : "")
                          }
                          placeholder="Enter Last Name"
                          onChange={(e) => {
                            setLastNameErr(false);
                            setLastName(e.target.value);
                          }}
                          defaultValue={lastName}
                        />
                      </div>
                    </div>
                    <div className="cmb-15 row g-3">
                      <label className="width-sm-25 d-flex align-items-center fs-15 text-dark text-nowrap">
                        Role
                      </label>
                      <div className="col">
                        <select
                          className={
                            "form-select input-md " +
                            (roleErr ? "is-invalid" : "")
                          }
                          aria-label="Default select example"
                          onChange={(e) => {
                            setRoleErr(false);
                            setRole(e.target.value);
                          }}
                          value={role}
                          disabled={true}
                        >
                          <option value="">Select Role</option>
                          <option value="Admin">Admin</option>
                        </select>
                      </div>
                    </div>
                    {errorMessage && (
                      <div className="text-danger text-center">
                        {" "}
                        {errorMessage}{" "}
                      </div>
                    )}
                    {successMessage && (
                      <div className="text-success text-center">
                        {" "}
                        {successMessage}{" "}
                      </div>
                    )}
                  </div>
                  <div className="card-footer bg-white d-flex p-3 border-top-0">
                    <div className="d-grid w-100">
                      <button
                        type="submit"
                        disabled={disabled}
                        className="btn btn-secondary btn-md text-white d-flex align-items-center justify-content-center px-4 fw-medium rounded-3 mx-1"
                      >
                        {disabled ? "Saving..." : "Save changes"}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </section>
      </main>
    </React.Fragment>
  );
}

export default MyAccount;
